// extracted by mini-css-extract-plugin
module.exports = {"c12hz4j4":"c12hz4j4","tpabb8a":"tpabb8a","d10gn6ek":"d10gn6ek","tnos9xz":"tnos9xz","s5k4ril":"s5k4ril","t1bqaarj":"t1bqaarj"};